import * as React from 'react';
import { Title, Section, Container } from '../modules/modules';
import { Registration as RegistrationForm } from '../components/Query/User';

class Registration extends React.Component {

  public render() {
    return (
      <main>
        <Section type="registration">
          <Container>
            <Title type="textPage">
              Customer registration
            </Title>
            <p>
              Signing up will make your future purchases easier - you will not have to enter anything besides your username and password.
            </p>
            <div className="registration">
              <RegistrationForm />
            </div>
          </Container>
        </Section>
      </main>
    );
  }
}

export default Registration;



// WEBPACK FOOTER //
// ./src/pages/Registration.tsx